import { BET_STARTED } from '../questionGame/actions'

const SET_BET_MS = 'SET_BET_MS'

export const betMs = (state = 30000, action) => {
    switch (action.type) {
        case SET_BET_MS:
        case BET_STARTED:
            return action.betMs

        default:
            return state
    }
}

export const setBetMs = (betMs) => {
    return { type: SET_BET_MS, betMs }
}


// WEBPACK FOOTER //
// ./src/reducers/betMs/index.js